import { queryOptions, useQuery } from '@tanstack/react-query';

import { conversationsApi } from '../api/conversations-api';

import { conversationKeys } from './conversation-keys';

export function conversationContextQueryOptions(storeId: string, id: string) {
  return queryOptions({
    queryKey: conversationKeys.context(storeId, id),
    queryFn: () => conversationsApi.context(storeId, id),
    // Cart and order state move slowly next to a chat; refreshed when the pane is reopened.
    staleTime: 30_000,
  });
}

export function useConversationContext(storeId: string, id: string) {
  return useQuery(conversationContextQueryOptions(storeId, id));
}
